/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_3_TagInputs */

const en_mk_parts_3_tag = /** @type {(inputs: Mk_Parts_3_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 — Workforce`)
};

const id_mk_parts_3_tag = /** @type {(inputs: Mk_Parts_3_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 — Tenaga kerja`)
};

/**
* | output |
* | --- |
* | "03 — Workforce" |
*
* @param {Mk_Parts_3_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_3_tag = /** @type {((inputs?: Mk_Parts_3_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_3_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_3_tag(inputs)
	return en_mk_parts_3_tag(inputs)
});